module.exports = __webpack_public_path__ + "img/ticket-now-gray.be6021af.svg";